<template>
  <TransitionRoot as="template" :show="open">
    <Dialog as="div" class="fixed z-10 zoom-80 inset-0 overflow-y-auto" @close="closeModal">
      <div
        class="flex items-end justify-center min-h-screen px-4 pb-20 text-center sm:block sm:p-0"
      >
        <TransitionChild
          as="template"
          enter="ease-out duration-300"
          enter-from="opacity-0"
          enter-to="opacity-100"
          leave="ease-in duration-200"
          leave-from="opacity-100"
          leave-to="opacity-0"
        >
          <DialogOverlay class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
        </TransitionChild>

        <!-- This element is to trick the browser into centering the modal contents. -->
        <span class="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">
          &#8203;
        </span>
        <TransitionChild
          as="template"
          enter="ease-out duration-300"
          enter-from="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
          enter-to="opacity-100 translate-y-0 sm:scale-100"
          leave="ease-in duration-200"
          leave-from="opacity-100 translate-y-0 sm:scale-100"
          leave-to="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
        >
          <div
            class="
              inline-block
              align-bottom
              bg-white
              rounded-lg
              px-4
              pb-4
              text-left
              overflow-hidden
              shadow-xl
              transform
              transition-all
              sm:my-8
              sm:align-middle
              sm:max-w-5xl
              sm:w-full
              sm:p-12
            "
          >
            <personal-learning-goals
              @learningGoalsAdded="learningGoalsAdded"
            ></personal-learning-goals>
          </div>
        </TransitionChild>
      </div>
    </Dialog>
  </TransitionRoot>
</template>

<script>
import { DialogOverlay, TransitionChild, TransitionRoot } from '@headlessui/vue';
import PersonalLearningGoals from '../PersonalLearningGoals.vue';

export default {
  name: 'ParticipantChecklist',
  props: {
    open: {
      type: Boolean,
      required: true,
    },
  },
  components: {
    DialogOverlay,
    TransitionChild,
    TransitionRoot,
    PersonalLearningGoals,
  },
  emits: ['closeLearningGoalsModal', 'learningGoalsAdded'],
  setup(props, { emit }) {
    const learningGoalsAdded = () => {
      emit('learningGoalsAdded');
    };

    const closeModal = () => {
      emit('closeLearningGoalsModal');
    };

    return { closeModal, learningGoalsAdded };
  },
};
</script>
